<template>
  <div>
    <main-loading v-if="isLoading"></main-loading>
    <h4 class="text-center">ประเภทห้องพัก</h4>
    <div class="text-red text-center" v-if="missingForm['addRoomType'] && !value.length">
      <i class="fas fa-exclamation-circle"></i> กรุณาเพิ่มประเภทห้องพัก
    </div>
    <div class="row">
      <div
        class="card mt-2 cost-firstime shadow"
        v-for="(roomType, index) in value"
        :key="index"
      >
        <div class="card-header">
          <div class="d-flex">
            <div class="input-group input-group-lg">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-lg"
                  >ชื่อประเภทห้อง <span class="required">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control input-lg"
                v-model="roomType.name"
                placeholder="เช่น ห้องมาตรฐาน ห้องสตูดิโอ ห้องใหญ่พิเศษ ห้องเตียงคู่ ห้องเตียงเดี่ยว"
                style="width: 300px"
                :class="{ 'is-invalid': missingForm['roomTypeName_'+index] }"
              />
            </div>
            <div class="btn-group ml-auto">
              <button
                type="button"
                class="btn btn-light"
                @click.prevent="deleteRoomType(index)"
              >
                <i class="fas fa-trash text-danger"></i>
              </button>
              <modal-confirm
                :id="`delete-room-modal-${index}`"
                :title="'ยืนยันการลบห้อง'"
                :content="`คุณต้องการลบห้อง ${roomType.name} นี้หรือไม่ ?`"
                :index="index"
                :onConfirm="confirmDelete"
              ></modal-confirm>
            </div>
          </div>
          <div class="input-group mt-2">
            <div class="input-group-prepend">
              <span class="input-group-text">ราคาค่าห้องขั้นต่ำ</span>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="roomType.cost"
              placeholder="ค่าห้อง บาท/เดือน"
            />
            <div class="input-group-append">
              <span class="input-group-text">บาท/เดือน</span>
            </div>
          </div>
          <div class="input-group mt-2">
            <div class="input-group-prepend">
              <span class="input-group-text">ราคาค่าห้องสูงสุด</span>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="roomType.maxCost"
              placeholder="ค่าห้อง บาท/เดือน"
            />
            <div class="input-group-append">
              <span class="input-group-text">บาท/เดือน</span>
            </div>
          </div>
          <div class="input-group mt-2">
            <div class="input-group-prepend">
              <span class="input-group-text">ขนาดห้อง</span>
            </div>
            <input
              type="text"
              class="form-control"
              v-model="roomType.size"
              placeholder="ขนาดห้อง (ตรม.)"
            />
            <div class="input-group-append">
              <span class="input-group-text">ตรม.</span>
            </div>
          </div>
          <div class="card mt-2">
            <div class="card-body">
              <p>
                <b
                  >จำนวนทั้งหมด {{ roomType.roomsSelected.length }} ห้อง
                  ในประเภทนี้</b
                >
              </p>
              <p>
                <span
                  v-for="(room, index) in roomType.roomsSelected"
                  :key="index"
                >
                  {{ room.get("roomId") }}
                  <span v-if="index !== roomType.roomsSelected.length - 1"
                    >,</span
                  >
                </span>
              </p>
              <button
                type="button"
                class="btn btn-primary btn-block mt-2"
                v-if="rooms"
                @click.prevent="openRoomSelectModal(index)"
              >
                <span
                  v-if="
                    !roomType.roomsSelected || !roomType.roomsSelected.length
                  "
                >
                  <i class="fas fa-plus"></i> คลิกที่นี่เพื่อเลือกห้อง
                </span>
                <span v-else> คลิกที่นี่เพื่อแก้ไขห้อง </span>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <h5>ค่าใช้จ่ายแรกเข้า</h5>
          <label class="mt-3"><b>การแสดงค่าใช้จ่ายแรกเข้าบนหน้าเว็บ</b></label>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="roomType.hideCost"
              :disabled="disabled"
            />
            <label class="form-check-label"
              >ไม่แสดงค่าใช้จ่ายแรกเข้าบนหน้าเว็บ</label
            >
          </div>
          <label class="mt-3"><b>ค่าใช้จ่ายต่างๆ</b></label>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="roomType.isAdvancedCost"
              :disabled="disabled"
            />
            <label class="form-check-label">เก็บค่าเช่าล่วงหน้า</label>
          </div>
          <div class="row">
            <div class="form-group col-md-6 col-sm-12">
              <label>ค่ามัดจำจอง</label>
              <input
                type="text"
                class="form-control"
                v-model="roomType.bookingCost"
                placeholder="ค่าจอง"
                :readonly="disabled"
              />
            </div>
            <div class="form-group col-md-6 col-sm-12">
              <label>เงินประกันห้อง</label>
              <input
                type="text"
                class="form-control"
                v-model="roomType.assuranceCost"
                placeholder="ค่าประกัน"
                :readonly="disabled"
              />
            </div>
            <div class="form-group col-md-6 col-sm-12">
              <label>ค่ากุญแจ</label>
              <input
                type="text"
                class="form-control"
                v-model="roomType.keyCost"
                placeholder="ค่ากุญแจ"
                :readonly="disabled"
              />
            </div>
            <div class="form-group col-md-6 col-sm-12">
              <label>ค่าคีย์การ์ด</label>
              <input
                type="text"
                class="form-control"
                v-model="roomType.keyCardCost"
                placeholder="ค่าคีย์การ์ด"
                :readonly="disabled"
              />
            </div>
            <apartment-feature-select
              v-model="roomType.roomFeature"
              :apartmentId="apartmentId"
              :facilities="roomFeatures"
              class="ml-3"
            />
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-hgn btn-block mt-4"
        @click.prevent="openRoomSelectModal()"
      >
        <i class="fas fa-plus"></i> เพิ่มประเภทห้อง
      </button>
      <modal-room-select
        :id="'room-select-modal'"
        :options="roomSelectModal"
        :rooms="rooms"
        :onSelected="onRoomSelect"
        :onClose="onRoomModalClosed"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
const ROOMTYPE_TEMPLATE = {
  id: null,
  name: null,
  cost: 0,
  size: null,
  roomFeature: [],
  bookingCost: 0,
  assuranceCost: 0,
  isAdvancedCost: true,
  keyCost: 0,
  keyCardCost: 0,
  costNote: null,
  availableRooms: [],
  isRoomAvailable: false,
  hideCost: false,
  maxRenter: 1,
  roomSelected: [],
};
export default {
  props: [
    "value",
    "disabled",
    "removedRoomTypes",
    "onDeleteRoomType",
    "id",
    "rooms",
    "apartmentId",
    "roomFeatures",
    "missingForm"
  ],
  watch: {
    value: {
      handler() {
        this.$emit("input", this.value);
      },
      deep: true,
    },
  },
  data() {
    return {
      selectedRoomIndex: 0,
      roomSelectModal: {
        isShow: false,
        roomType: null,
      },
      isLoading: false,
    };
  },
  methods: {
    openRoomSelectModal(index) {
      this.roomSelectModal.roomType = null;
      if (typeof index === "number") {
        this.roomSelectModal.roomType = this.value[index];
      }
      this.roomSelectModal.isShow = true;
    },
    onRoomSelect(rooms, roomType) {
      if (!roomType) {
        this.onNewRoomSelect(rooms);
        return;
      }
      if (roomType.roomsSelected && roomType.roomsSelected.length > 0) {
        let costs = roomType.roomsSelected.map((r) => {
          if (r.get("roomRate")) {
            let roomCost = 0;
            try {
              if (r.get("roomRate").get("roomCost_month"))
                roomCost = r.get("roomRate").get("roomCost_month");
            } catch (error) {
              // eslint-disable-next-line
            }
            return roomCost + this.getFurnitureCost(r);
          } else {
            return 0;
          }
        });
        roomType.cost = _.min(costs);
        roomType.maxCost = _.max(costs);
      } else {
        roomType.cost = 0;
        roomType.maxCost = 0;
      }
      //reset roomtype select
      this.rooms.map((r) => {
        if (r.roomType == roomType) r.roomType = null;
      });
      rooms.map((r) => {
        r.roomType = roomType;
      });
      this.$mount();
    },
    async onNewRoomSelect(rooms) {
      //create blank roomType
      let RoomType = this.Parse.Object.extend("DraftRoomType");
      let rt = new RoomType();
      this.isLoading = true;
      await rt.save();
      this.isLoading = false;

      let roomType = Object.assign({}, ROOMTYPE_TEMPLATE);
      roomType.name = ``;
      roomType.roomsSelected = rooms;
      roomType.objectId = rt.id;
      if (roomType.roomsSelected && roomType.roomsSelected.length > 0) {
        let costs = roomType.roomsSelected.map((r) => {
          let roomCost = 0;
          try {
            if (r.get("roomRate"))
              roomCost = r.get("roomRate").get("roomCost_month");
          } catch (error) {
            // eslint-disable-next-line
          }
          return roomCost + this.getFurnitureCost(r);
        });
        roomType.cost = _.min(costs);
        roomType.maxCost = _.max(costs);
      } else {
        roomType.cost = 0;
        roomType.maxCost = 0;
      }
      rooms.map((r) => {
        r.roomType = roomType;
      });
      this.value.push(roomType);
    },
    getFurnitureCost(room) {
      if (room.get("servicesRate")) {
        for (let cost of room.get("servicesRate")) {
          if (cost["name_en"] === "Furniture rate") {
            if (cost["cost_month"]) return cost["cost_month"];
            else return 0;
          }
        }
      }
      return 0;
    },
    deleteRoomType(index) {
      // eslint-disable-next-line
      $(`#delete-room-modal-${index}`).modal();
    },
    onRoomModalClosed() {
      this.roomSelectModal.isShow = false;
    },
    confirmDelete(index) {
      // eslint-disable-next-line
      $(`#delete-room-modal-${index}`).modal("hide");
      let deleteRoomTypeId = this.value[index].objectId;
      this.rooms.map((r) => {
        if (r.roomType && r.roomType.objectId === deleteRoomTypeId) {
          delete r.roomType;
        }
      });
      this.onDeleteRoomType(this.value[index].objectId);
      this.value.splice(index, 1);
      this.$emit("input", this.value);
    },
    orderUp(index) {
      if (index !== 0) {
        let tmp = this.value[index];
        this.value[index] = this.value[index - 1];
        this.value[index - 1] = tmp;
      }

      this.$emit("input", this.value);
      this.$mount();
    },
    orderDown(index) {
      if (index !== this.value.length - 1) {
        let tmp = this.value[index];
        this.value[index] = this.value[index + 1];
        this.value[index + 1] = tmp;
      }

      this.$emit("input", this.value);
      this.$mount();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";
.add-btn {
  cursor: pointer;
  background-color: $primary-color;
  color: white;
}

.img-preview {
  width: 200px;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 0.25em;
}

.img-item {
  padding: 10px;
  height: 150px;
  width: 100%;
  margin-bottom: 10px;
}

.upload-box {
  height: 500px;
  overflow-y: auto;
}

.btn-hgn {
  background-color: #fff5e9 !important;
  color: $primary-color !important;
  border-color: $primary-color !important;
  border-style: solid;
  border-width: 1px;
}

.cost-firstime {
  width: 100%;
}

.text-red {
  color: red;
}
</style>

